import React from 'react';
import PropTypes from 'prop-types';
import SimpleMarkdown from 'simple-markdown';

/**
 * @example
 * [indent]
 * Hello world.
 *
 * I feel like a pickle.
 * [/indent]
 */

const regex = /^\[indent]((?:[\w\W](?!\[\/indent]))+[\w\W])\[\/indent]/;

const indentedRule = {
  order: SimpleMarkdown.defaultRules.paragraph.order - 0.5,
  match: (source) => regex.exec(source),
  parse: (capture, recurseParse, state) => {
    const [, content] = capture;
    return {
      content: recurseParse(`${content}\n`, state)
    };
  },
  react({content}, output, {key}) {
    return (
      <div key={key} className='u-mar-l_4'>
        {output(content)}
      </div>
    );
  }
};

indentedRule.react.propTypes = {
  content: PropTypes.node
};

export default indentedRule;
